// src/auth/useUser.ts
import { useEffect, useState } from "react";
import { useAuth } from "../KeycloakProvider";
import { useAxios } from "./useAxios";
import { createNewUser, findUserByKeycloakId } from "../utils/User/User.axios";
import { generateEmptyUser } from "../utils/User/User.utils";
import { User } from "../utils/User/User.types";

export const useUser = () => {
  const { keycloak, authenticated, initialized } = useAuth();
  const { axios } = useAxios();
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (!initialized || !axios || !authenticated || loading || user) return;
    if (!keycloak.tokenParsed?.sub) return;

    const keycloakId = keycloak.tokenParsed.sub;

    findUserByKeycloakId(axios, keycloakId)
      .then(async (loadedUser) => {
        if (loadedUser) {
          setUser(loadedUser);
          return;
        }

        const profile = await keycloak.loadUserProfile();
        const newUser = generateEmptyUser({
          keycloakId,
          username: `${profile.firstName} ${profile.lastName}`,
          email: profile.email,
          raceTag: profile.lastName?.slice(0, 2),
        });
        const created = await createNewUser(axios, newUser);
        setUser(created);
      })
      .finally(() => setLoading(false));
  }, [initialized, authenticated, keycloak, axios, loading, user]);

  return { user, loading };
};
